export default __webpack_public_path__ + "static/media/06_PIEDS_MILITAIRES-min.ffadbe6f.jpg";